export default {
  install(Vue) {
    Vue.prototype.$extension = {
      sendTask: function (
        docID,
        selectedItems,
        syncToolID = ""
      ) {
        return new Promise(async (resolve, reject) => {
          try {
            let res = await window.NxVetV2.generateExtensionTask(
              docID,
              selectedItems,
              {
                protocol: "socket",
                syncToolID,
              }
            );
            console.log(res);

            if (res.result && res.result.emitError) {
              if (res.result.request) {
                $.ajax({
                  type: "POST",
                  url: `http://127.0.0.1:9002/`,
                  data: JSON.stringify(res.result),
                  dataType: "json",
                  contentType: "application/json",
                  success: (xhr) => {
                    console.log("Success: post exam to local sync tool");
                    resolve(res);
                  },
                  error: (xhr, ajaxOptions, thrownError) => {
                    console.log("Fail: post exam to local sync tool");
                    reject("Fail: post exam to local sync tool");
                  },
                });
              }
            } else {
              resolve(res);
            }
          } catch (error) {
            console.log(error);
            reject(error);
          }
        });
      },
    };
  },
};
